import { render, staticRenderFns } from "./LocalidadeOnccaArgentina.vue?vue&type=template&id=394b271b&lang=pug"
import script from "./LocalidadeOnccaArgentina.vue?vue&type=script&lang=js"
export * from "./LocalidadeOnccaArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports